var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ImageData, getPointPercentage } from "../Helpers/Image.ts";
var ImageCropper = /** @class */ (function (_super) {
    __extends(ImageCropper, _super);
    function ImageCropper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.desiredSize = { width: _this.width, height: _this.height };
        _this.img = null;
        _this.offset = {
            x: 0,
            y: 0
        };
        _this.panning = false;
        _this.scale = 1;
        return _this;
    }
    Object.defineProperty(ImageCropper.prototype, "localValue", {
        get: function () {
            if (!this.img)
                return { x1: 0, x2: 0, y1: 0, y2: 0 };
            return this.img.getCrop(this.desiredSize, this.offset, this.scale);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageCropper.prototype, "size", {
        get: function () {
            if (!this.img)
                return { width: 0, height: 0 };
            return this.img.scale(this.scale);
        },
        enumerable: true,
        configurable: true
    });
    ImageCropper.prototype.onOffsetXChanged = function (val) { this.offset.x = this.img ? this.img.guardOffset(this.offset, this.desiredSize, this.scale).x : val; };
    ImageCropper.prototype.onOffsetYChanged = function (val) { this.offset.y = this.img ? this.img.guardOffset(this.offset, this.desiredSize, this.scale).y : val; };
    ImageCropper.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        window.document.addEventListener("mousemove", this.onMouseMove);
                        window.document.addEventListener("mouseup", this.onMouseUp);
                        return [4 /*yield*/, this.reset()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ImageCropper.prototype.beforeDestroy = function () {
        window.document.removeEventListener("mousemove", this.onMouseMove);
        window.document.removeEventListener("mouseup", this.onMouseUp);
    };
    ImageCropper.prototype.onSrcChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.processImage()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ImageCropper.prototype.reset = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.processImage(this.value)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ImageCropper.prototype.processImage = function (crop) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.resetting = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 5, 6]);
                        _a = this;
                        return [4 /*yield*/, ImageData.create(this.src, this.desiredSize, crop)];
                    case 2:
                        _a.img = _b.sent();
                        this.scale = this.img.initialScale;
                        return [4 /*yield*/, Vue.nextTick()];
                    case 3:
                        _b.sent();
                        this.offset = this.img.center(this.img.cropCenter, this.desiredSize, this.scale);
                        return [4 /*yield*/, Vue.nextTick()];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this.resetting = false;
                        return [7 /*endfinally*/];
                    case 6:
                        this.$emit("input", this.localValue);
                        return [2 /*return*/];
                }
            });
        });
    };
    ImageCropper.prototype.onMouseDown = function (ev) {
        if (ev.buttons !== 1)
            return;
        this.panning = true;
        this.lastX = ev.screenX;
        this.lastY = ev.screenY;
    };
    ImageCropper.prototype.onMouseMove = function (ev) {
        if (!this.panning)
            return;
        if (ev.buttons !== 1) {
            this.onMouseUp(ev);
            return;
        }
        if (this.lastX === undefined || this.lastY === undefined)
            return;
        this.offset = {
            y: this.offset.y + ev.screenY - this.lastY,
            x: this.offset.x + ev.screenX - this.lastX
        };
        this.lastX = ev.screenX;
        this.lastY = ev.screenY;
    };
    ImageCropper.prototype.onMouseUp = function (ev) {
        if (!this.panning)
            return;
        this.panning = false;
        this.lastX = undefined;
        this.lastY = undefined;
        if (!this.resetting) {
            this.$emit("input", this.localValue);
        }
    };
    ImageCropper.prototype.onScaleChanged = function (val, old) {
        if (!this.img)
            return;
        // Set the scale to bounded value to be sure it doesn't go outside the bounds;
        //
        this.scale = this.img.guardScale(val);
        // Only run the centering logic if the old scale is not outside the bounds.
        // If it is, this means that this method already ran with the corrected scope
        // and this is just a re-execution to get the value inside the bounds again.
        //
        if (this.img.guardScale(old) === old) {
            var centerLeft = this.desiredSize.width / 2;
            var centerTop = this.desiredSize.height / 2;
            var oldCenter = getPointPercentage(// find center point using old scale settings
            { x: centerLeft, y: centerTop }, this.offset, this.img.scale(old));
            this.offset = {
                x: -(this.size.width * oldCenter.x) + centerLeft,
                y: -(this.size.height * oldCenter.y) + centerTop
            };
            if (!this.resetting) {
                this.$emit("input", this.localValue);
            }
        }
    };
    Object.defineProperty(ImageCropper.prototype, "scaleStep", {
        get: function () {
            if (!this.img)
                return 0;
            return (this.img.maxScale - this.img.minScale) / 6;
        },
        enumerable: true,
        configurable: true
    });
    ImageCropper.prototype.onZoomOut = function () {
        this.scale -= this.scaleStep;
    };
    ImageCropper.prototype.onZoomIn = function () {
        this.scale += this.scaleStep;
    };
    ImageCropper.prototype.pixelize = function (value) {
        return value
            ? value + "px"
            : value;
    };
    __decorate([
        Prop({ type: Boolean, default: false })
    ], ImageCropper.prototype, "fill", void 0);
    __decorate([
        Prop({ type: String })
    ], ImageCropper.prototype, "borderRadius", void 0);
    __decorate([
        Prop({ type: Number, required: true, validator: function (val) { return val && val > 0; } })
    ], ImageCropper.prototype, "width", void 0);
    __decorate([
        Prop({ type: Number, required: true, validator: function (val) { return val && val > 0; } })
    ], ImageCropper.prototype, "height", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], ImageCropper.prototype, "src", void 0);
    __decorate([
        Prop({ type: Object })
    ], ImageCropper.prototype, "value", void 0);
    __decorate([
        Watch("offset.x")
    ], ImageCropper.prototype, "onOffsetXChanged", null);
    __decorate([
        Watch("offset.y")
    ], ImageCropper.prototype, "onOffsetYChanged", null);
    __decorate([
        Watch("src")
    ], ImageCropper.prototype, "onSrcChanged", null);
    __decorate([
        Watch("scale")
    ], ImageCropper.prototype, "onScaleChanged", null);
    ImageCropper = __decorate([
        Component({
            name: "ImageCropper"
        })
    ], ImageCropper);
    return ImageCropper;
}(Vue));
export default ImageCropper;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/ImageCropper.vue
// module id = 874
// module chunks = 6